import ToolTip from "../ToolTip/ToolTip";
export default function ProgressBar({
  status,
  success,
  failed,
  total,
  showPercentage = 0,
  revoked = 0,
  deleted = 0,
}) {
  const isInProgress = status === "in-progress";
  const isPartiallyIssued = status === "partially-issued";
  const isPartiallyRevoked = status === "partially-revoked";
  const isPartiallyIssuedAndRevoked = status === "partially-issued-and-revoked";

  const pending = Math.max(total - success - failed - revoked - deleted, 0);

  const successPercentage = total > 0 ? (success / total) * 100 : 0;
  const failedPercentage = total > 0 ? (failed / total) * 100 : 0;
  const revokedPercentage = total > 0 ? (revoked / total) * 100 : 0;
  const deletedPercentage = total > 0 ? (deleted / total) * 100 : 0;
  const pendingPercentage = total > 0 ? (pending / total) * 100 : 0;

  const tooltipContent = (
    <div className="relative flex flex-col gap-1 text-white">
      <div>
        {success > 0 && (
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-cfIssuedCredentialTemplateCardStatusDoneBG rounded-full" />
            <span>Issued: {success}</span>
          </div>
        )}
        {revoked > 0 && (
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-cfIssuedCredentialTemplateCardStatusRevokedBG rounded-full" />
            <span>Revoked: {revoked}</span>
          </div>
        )}
        {failed > 0 && (
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-cfIssuedCredentialTemplateCardStatusFailedBG rounded-full" />
            <span>Failed: {failed}</span>
          </div>
        )}
        {deleted > 0 && (
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-cfDisabledDeleteColor rounded-full" />
            <span>Deleted: {deleted}</span>
          </div>
        )}
        {pending > 0 && isInProgress && (
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-cfIssuedCredentialTemplateCardStatusUnderReviewBG rounded-full" />
            <span>Pending: {pending}</span>
          </div>
        )}
        <div className="border-t pt-1 mt-1">
          <span className="font-medium">Total: {total}</span>
        </div>
      </div>
    </div>
  );

  const progressBar = (
    <div className="relative min-w-[8rem]">
      <div className="h-3 bg-gray-200 rounded-full overflow-hidden relative">
        <div className="h-full flex">
          {successPercentage > 0 && (
            <div
              className="bg-cfIssuedCredentialTemplateCardStatusDoneBG transition-all duration-500"
              style={{
                width: `${successPercentage}%`,
              }}
            />
          )}
          {failedPercentage > 0 && (
            <div
              className="bg-cfIssuedCredentialTemplateCardStatusFailedBG transition-all duration-500"
              style={{ width: `${failedPercentage}%` }}
            />
          )}
          {revokedPercentage > 0 && (
            <div
              className={`${"bg-cfIssuedCredentialTemplateCardStatusRevokedBG"} transition-all duration-500`}
              style={{
                width: `${revokedPercentage}%`,
              }}
            />
          )}
          {deletedPercentage > 0 && (
            <div
              className="bg-cfDisabledDeleteColor transition-all duration-500"
              style={{
                width: `${deletedPercentage}%`,
              }}
            />
          )}
          {pendingPercentage > 0 && isInProgress && (
            <div
              className="bg-cfIssuedCredentialTemplateCardStatusUnderReviewBG transition-all duration-500"
              style={{
                width: `${pendingPercentage}%`,
              }}
            />
          )}
        </div>
        {/* Centered label inside the progress bar */}
        <span
          className={`absolute text-white left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-xs font-medium select-none z-10 text-white"}`}
        >
          {showPercentage}%
        </span>
      </div>
      {isInProgress && (
        <div className="absolute top-0 left-0 h-3 w-full overflow-hidden rounded-full pointer-events-none">
          <div className="h-full bg-gradient-to-r from-transparent via-white/30 to-transparent animate-pulse" />
        </div>
      )}
    </div>
  );

  const showTooltip =
    isInProgress ||
    isPartiallyIssued ||
    isPartiallyRevoked ||
    isPartiallyIssuedAndRevoked ||
    total > 0;

  return (
    <div className="flex items-center justify-center w-full">
      {showTooltip ? (
        <ToolTip
          component={progressBar}
          message={tooltipContent}
          tooltipPosition={"bottom-[0.2rem]"}
          bgColor="#3538CD"
        />
      ) : (
        progressBar
      )}
    </div>
  );
}
